import {StyleSheet} from 'react-native';

import platformConfig from '/config/platform.config';
import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    paddingHorizontal: 12,
    paddingVertical: 25,
  },
  container: {
    borderColor: alto,
    borderWidth: 1,
    width: '91%',
    borderRadius: 4,
    marginLeft: indent * 1,
  },
  accordionTitle: {
    fontWeight: platformConfig.select({ios: '700', android: 'bold'}),
    fontSize: 16,
  },
  accordionBody: {
    paddingTop: indent * 0.1,
    marginLeft: indent * 0.1,
    marginRight: indent * 0.2,
    marginTop: indent * 0.2,
    fontSize: 16,
  },
  reassignedButton: {
    justifyContent: 'center',
    width: '100%',
    borderRadius: 8,
    marginTop: indent,
    marginBottom: indent * 0.5,
    height: 40,
    color: white,
    fontWeight: platformConfig.select({ios: '700', android: 'bold'}),
  },
});
